import React, { useRef, useEffect } from "react";
import styles from "./ContactModal.scss";
import DiscordMessageSend from "../../../../utils/Discord-message-send";

export function ContactModal({ isOpen, onClose }) {
  const formRef = useRef(null);
  const modalRef = useRef(null);

  // ESCキーで閉じる
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  // オーバーレイクリックで閉じる
  const handleOverlayClick = (e) => {
    if (e.target === modalRef.current) {
      onClose();
    }
  };

  // フォーム送信
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formRef.current) return;

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://vgdr5k3cwrrk4c7ehcebdsp4he0okmgj.lambda-url.ap-northeast-1.on.aws/", true);
    xhr.setRequestHeader("content-type", "text/plain");
    const request = `name=${formRef.current.user_name.value}&email=${formRef.current.user_email.value}&message=${formRef.current.message.value}`;
    xhr.send(request);
    alert("メールを送信しました。");

    DiscordMessageSend(
      "mail",
      `${formRef.current.user_name.value}様（${formRef.current.user_email.value}）からお問い合わせです。以下本文：${formRef.current.message.value}`
    );

    formRef.current.reset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div ref={modalRef} className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose} aria-label="閉じる">
          <span></span>
          <span></span>
        </button>

        <h2 className={styles.modalTitle}>お問い合わせ</h2>
        <p className={styles.modalDescription}>
          ご質問やご要望がございましたら、以下のフォームよりお気軽にお問い合わせください。
        </p>

        <form ref={formRef} onSubmit={handleSubmit} className={styles.contactForm}>
          <div className={styles.formGroup}>
            <label htmlFor="user_name">お名前</label>
            <input type="text" id="user_name" name="user_name" required />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="user_email">メールアドレス</label>
            <input type="email" id="user_email" name="user_email" required />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="message">お問い合わせ内容</label>
            <textarea id="message" name="message" rows="5" required />
          </div>
          <button type="submit" className={styles.submitButton}>
            送信する
          </button>
        </form>
      </div>
    </div>
  );
}
